module.exports = __webpack_public_path__ + "static/media/Screenshot_1.af2aca24.png";